import axios from "axios";

// Sur localhost : toujours /api (proxy vers backend local). Sinon VITE_API_URL ou /api
function getDefaultBaseURL(): string {
  if (
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1")
  ) {
    return "/api";
  }
  const buildTimeUrl = import.meta.env.VITE_API_URL || "/api";
  return typeof buildTimeUrl === "string" && buildTimeUrl.endsWith("/api")
    ? buildTimeUrl
    : `${String(buildTimeUrl).replace(/\/$/, "")}/api`;
}

export const api = axios.create({
  baseURL: getDefaultBaseURL(),
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// Intercepteur : sur localhost, forcer /api (évite cache + .env Scaleway)
api.interceptors.request.use(
  (config) => {
    if (
      typeof window !== "undefined" &&
      (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1")
    ) {
      config.baseURL = "/api";
      // Forcer l'URL complète vers le proxy local (axios peut avoir déjà config.url en absolu)
      if (config.url && typeof config.url === "string" && config.url.startsWith("http")) {
        try {
          const u = new URL(config.url);
          config.url = "/api" + u.pathname.replace(/^\/api/, "") + u.search;
        } catch {
          config.baseURL = "/api";
        }
      }
    }
    const token =
      typeof window !== "undefined"
        ? sessionStorage.getItem("token") || localStorage.getItem("token")
        : null;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Intercepteur pour gérer les erreurs globales
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      sessionStorage.removeItem("token");
      localStorage.removeItem("token");
      delete api.defaults.headers.common["Authorization"];
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  },
);
